// extracted by mini-css-extract-plugin
export default {"header":"MobileModalHeader_header__q09ZS","backButton":"MobileModalHeader_backButton__IGbiU","title":"MobileModalHeader_title__Qt60X","spacer":"MobileModalHeader_spacer__MMDEq"};